import React from 'react';
import styles from './styles.module.scss';

import LinkWrap from '../../Wraps/LinkWrap';
import ImagePlaceholder from '../../Placeholder';

import Config, { spanish } from '../../../config/config';

import placeholder from '../../../assets/placeholder/400x560.jpg';

const Item = ({
  seo,
  imageMobile,
  imageDesktop,
  product,
  category,
  url,
  isExternal,
}) => {
  let linkTo = url;
  let linkState = {};
  if (product !== null) {
    linkTo = `/product/${product?.SLUG}`;
    linkState = { sku: product?.SKU };
  } else if (category !== null) {
    linkTo = `/category/${category?.SLUG}`;
    linkState = {
      categoryId: category?.categoryID,
      categoryName: spanish ? category?.NameSpanish : category?.NameEnglish,
    };
  }
  return (
    linkTo !== null && (
      <LinkWrap
        to={linkTo}
        className={styles.item}
        state={linkState}
        isExternal={isExternal}
      >
        {seo && imageMobile && imageDesktop ? (
          <picture>
            <source
              srcSet={`${Config.cdn.cdn_path}${imageDesktop}`}
              media="(min-width: 1025px)"
            />
            <img src={`${Config.cdn.cdn_path}${imageMobile}`} alt={seo} />
          </picture>
        ) : (
          <ImagePlaceholder mobile={placeholder} />
        )}
      </LinkWrap>
    )
  );
};

const MiddleBanners = ({ data }) => {
  const left = data?.find((item) => item?.Position === 'MiddleLeft');
  const center = data?.find((item) => item?.Position === 'MiddleCenter');
  const right = data?.find((item) => item?.Position === 'MiddleRight');
  return (
    <div className={styles.container}>
      <Item
        seo={left?.SEO}
        imageMobile={
          spanish ? left?.imageMobile?.url : left?.imageMobileEnglish?.url
        }
        imageDesktop={
          spanish ? left?.imageDesktop?.url : left?.imageDesktopEnglish?.url
        }
        product={left?.product}
        category={left?.category}
        url={left?.LinkTo}
        isExternal={left?.isExternal}
      />
      <Item
        seo={center?.SEO}
        imageMobile={
          spanish ? center?.imageMobile?.url : center?.imageMobileEnglish?.url
        }
        imageDesktop={
          spanish ? center?.imageDesktop?.url : center?.imageDesktopEnglish?.url
        }
        product={center?.product}
        category={center?.category}
        url={center?.LinkTo}
        isExternal={center?.isExternal}
      />
      <Item
        seo={right?.SEO}
        imageMobile={
          spanish ? right?.imageMobile?.url : right?.imageMobileEnglish?.url
        }
        imageDesktop={
          spanish ? right?.imageDesktop?.url : right?.imageDesktopEnglish?.url
        }
        product={right?.product}
        category={right?.category}
        url={right?.LinkTo}
        isExternal={right?.isExternal}
      />
    </div>
  );
};

export default MiddleBanners;
